import { apiGet } from "../baseApi";

import { setOngoingIncidentData } from "service/mapper";
import { isValidValue } from "utils";

export const ongoingList = async ({params={}, config = {}}) => {
  try {
    const response = await apiGet("_ongoingincident", params, null, config);
    if (!isValidValue(response.data)) {
      response.data = [];
    }
    return {
      ...response,
      rowData: (Array.isArray(response.data) ? response.data : []).map((el) => setOngoingIncidentData(el)),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
